import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/lib/consent';

/**
 * Fires an analytics page view on route changes.
 *
 * Automatic page_view tracking is switched off in index.html because the app
 * is a single-page app and the tag would otherwise measure every internal
 * route. This sends a view only for routes that are explicitly measurable, and
 * only once analytics consent has been recorded.
 */
export const AnalyticsPageView: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    trackPageView(pathname);
  }, [pathname]);

  return null;
};

export default AnalyticsPageView;
